"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = exports.WarningLabel = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const RESERVEDDatasourceCanInfoIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanInfoIcon");
const RESERVEDDatasourceCanWarningIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanWarningIcon");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelIcons_1 = require("../LabelIcons");
const LabelPopover_1 = require("../LabelPopover");
const LabelType_1 = require("../shared/LabelType");
const useControlledPopover_1 = require("../shared/useControlledPopover");
const Styles_1 = require("../Styles");
function warningLabelTitle(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    switch (props.kind) {
        case 'dehydrated': {
            return warningLabelTitleCalculation(props.count, props.labelValue);
        }
        case 'hydrated': {
            const count = ((_b = (_a = props.anchored) === null || _a === void 0 ? void 0 : _a.labels.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = props.upstream) === null || _c === void 0 ? void 0 : _c.labels.length) !== null && _d !== void 0 ? _d : 0)
                + ((_f = (_e = props.parented) === null || _e === void 0 ? void 0 : _e.labels.length) !== null && _f !== void 0 ? _f : 0);
            const labelType = (_q = (_m = (_j = (_h = (_g = props.anchored) === null || _g === void 0 ? void 0 : _g.labels[0]) === null || _h === void 0 ? void 0 : _h.type) !== null && _j !== void 0 ? _j : (_l = (_k = props.parented) === null || _k === void 0 ? void 0 : _k.labels[0]) === null || _l === void 0 ? void 0 : _l.type) !== null && _m !== void 0 ? _m : (_p = (_o = props
                .upstream) === null || _o === void 0 ? void 0 : _o.labels[0]) === null || _p === void 0 ? void 0 : _p.type) !== null && _q !== void 0 ? _q : '';
            return warningLabelTitleCalculation(count, labelType);
        }
        default:
            (0, catalog_core_1.assertUnreachable)(props);
            return '';
    }
}
function warningLabelTitleCalculation(count, labelType) {
    if (count <= 0) {
        return '';
    }
    if (count === 1) {
        return labelType in LabelType_1.LabelType ? (0, LabelType_1.localizeLabelTypeName)((0, LabelType_1.stringtoLabelType)(labelType)) : labelType;
    }
    return catalog_messages_1.Messages.Label_quality_warning_chip_message({
        MESSAGE_COUNT: count,
        MESSAGE_COUNT_LOC: catalog_messages_1.Formatters.formatCount(count),
    });
}
function warningIsSevere(props) {
    var _a, _b, _c, _d;
    if (!props) {
        return false;
    }
    switch (props === null || props === void 0 ? void 0 : props.kind) {
        case 'hydrated':
            if (((_a = props.anchored) === null || _a === void 0 ? void 0 : _a.labels.some(w => w.severe)) || ((_b = props.parented) === null || _b === void 0 ? void 0 : _b.labels.some(w => w.severe))) {
                return true;
            }
            break;
        case 'dehydrated':
            return props.severe;
        default:
            (0, catalog_core_1.assertUnreachable)(props);
    }
    return (_d = (_c = props === null || props === void 0 ? void 0 : props.upstream) === null || _c === void 0 ? void 0 : _c.labels.some(w => w.severe)) !== null && _d !== void 0 ? _d : false;
}
function WarningLabel(props) {
    var _a, _b, _c, _d;
    const popover = (0, useControlledPopover_1.useControlledPopover)({
        testId: props.testId,
        popoverProps: {
            title: warningLabelTitle(props),
            placement: (_b = (_a = props.controls) === null || _a === void 0 ? void 0 : _a.popoverPlacement) !== null && _b !== void 0 ? _b : 'bottom-start',
        },
        content: LabelPopover_1.LabelPopover,
        controlKind: (_d = (_c = props.controls) === null || _c === void 0 ? void 0 : _c.kind) !== null && _d !== void 0 ? _d : 'icon',
        iconProps: warningIconProps,
        chipProps: warningChipProps,
        onClick: props.onClick,
        loading: props.loading,
        props: Object.assign({}, props),
        severe: warningIsSevere(props),
        renderMode: props.renderMode,
    });
    return popover !== null && popover !== void 0 ? popover : react_1.default.createElement(react_1.default.Fragment, null);
}
exports.WarningLabel = WarningLabel;
function warningChipProps(severe) {
    return {
        stickerType: severe ? 'yellow' : 'blue',
        icon: severe
            ? react_1.default.createElement(RESERVEDDatasourceCanWarningIcon_1.RESERVEDDatasourceCanWarningIcon, { size: 14, alt: catalog_messages_1.Messages.DataQualityTypeWarning(), color: '#AC4B02' })
            : react_1.default.createElement(RESERVEDDatasourceCanInfoIcon_1.RESERVEDDatasourceCanInfoIcon, { size: 14, alt: catalog_messages_1.Messages.DataQualityTypeWarning(), color: '#05628A' }),
        kind: 'sticker-props',
    };
}
function warningIconProps(severe) {
    return {
        getContent: (s) => react_1.default.createElement(WarningIcon, { hover: s.hover, isSevere: () => severe }),
        style: {
            padding: widgets_1.TabStyles.Spacing.SmallSpace,
            cursor: 'pointer',
        },
        buttonType: widgets_1.ButtonType.Icon,
        kind: 'button-props',
    };
}
function WarningIcon(props) {
    const severe = props.isSevere();
    if (props.hover) {
        return severe
            ? react_1.default.createElement(LabelIcons_1.WarningHighSeverityIcon, { className: Styles_1.LabelIconHoverClass })
            : react_1.default.createElement(LabelIcons_1.WarningStandardSeverityIcon, { className: Styles_1.LabelIconHoverClass });
    }
    else {
        return severe
            ? react_1.default.createElement(LabelIcons_1.WarningHighSeverityIcon, { className: Styles_1.LabelIconClass })
            : react_1.default.createElement(LabelIcons_1.WarningStandardSeverityIcon, { className: Styles_1.LabelIconClass });
    }
}
exports.WarningIcon = WarningIcon;
//# sourceMappingURL=WarningButton.js.map